import { isNil } from 'lodash'

const nullToString = (inVal) => {
    return (isNil(inVal)) ? '' : inVal
}

export default nullToString